import React from "react";
import { Button } from "../ui/button";

export const PageTitle = (
  { title, hasSubtitle, buttonText, onButtonClick, buttonDisabled, buttonIcon }:
    { title: string, hasSubtitle?: boolean, buttonText?: string, onButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void, buttonDisabled?: boolean, buttonIcon?: React.ReactNode }
) => {
  return (
    <div className={`flex flex-row items-center justify-between w-full mt-2 ${hasSubtitle ? 'mb-4' : 'mb-10'}`}>
      <h1 className="text-primary font-bold text-3xl">{title}</h1>
      {buttonText && (
        <Button
          type="button"
          className="w-auto font-semibold"
          onClick={onButtonClick}
          disabled={buttonDisabled}
        >
          {buttonIcon && <span className="mr-1.5">{buttonIcon}</span>}
          {buttonText}
        </Button>
      )}
    </div>
  );
};
